<template>
  <div class="card card-body text-start mb-3 cuerpoDetalle">
    <h5 class="card-title">Índice de pagos</h5>
    <div class="mt-3 mb-2">
      <h5>{{ $filters.CapitalizeFilter(cliente.nombre) }}</h5>
      <div class="container row justify-content-end mb-3">
        <div class="col-3">
          <div class="noContratos text-center">
            <p class="m-0">
              Contratos <span>{{ totalContratos }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="container row align-items-center mb-3">
        <div class="col-2">
          <p class="m-0 fw-bold">Eficiencia de pagos</p>
        </div>
        <div
          class="col"
          style="border: 1px solid rgb(187, 204, 221); border-radius: 4px"
        >
          <div
            class="row align-items-center justify-content-center fw-bold fs-5"
          >
            <div class="col text-center">
              <p class="mt-2 mb-2">{{ eficienciaPagoIntegrante }}%</p>
            </div>
            <div class="col text-center" v-if="adjudicatarios">
              <p class="mt-2 mb-2">{{ eficienciaPagoAdjudicatario }}%</p>
            </div>
            <div class="col text-center">
              <p class="mt-2 mb-2">{{ eficienciaPagoTotal }}%</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container row align-items-center mb-3">
        <div class="col offset-2">
          <DoughnutChart
            :chartData="datosIntegrante"
            width="100px"
            height="100px"
          />
          <p class="text-center">Integrante</p>
        </div>
        <div class="col" v-if="adjudicatarios">
          <DoughnutChart
            :chartData="datosAdjudicatario"
            width="100px"
            height="100px"
          />
          <p class="text-center">Adjudicatario</p>
        </div>
        <div class="col">
          <DoughnutChart :chartData="datosTotal" width="100px" height="100px" />
          <p class="text-center">Total</p>
        </div>
      </div>
      <div class="container mb-3">
        <div class="row">
          <p class="fw-bold" style="color: rgb(110, 117, 153)">
            Número de cuotas
          </p>
        </div>
        <div class="row">
          <div class="col-2">
            <div class="d-flex me-2">
              <div class="rectangulo anticipos me-1"></div>
              <p>Anticipos</p>
            </div>
          </div>
          <div class="col text-center">
            <p>{{ integrante.integranteAnticipo }}</p>
          </div>
          <div class="col text-center" v-if="adjudicatarios">
            <p>{{ adjudicatario.adjudicatarioAnticipo }}</p>
          </div>
          <div class="col text-center">
            <p>{{ total.totalAnticipo }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <div class="d-flex me-2">
              <div class="rectangulo puntuales me-1"></div>
              <p>Puntuales</p>
            </div>
          </div>
          <div class="col text-center">
            <p>{{ integrante.integrantePuntuales }}</p>
          </div>
          <div class="col text-center" v-if="adjudicatarios">
            <p>{{ adjudicatario.adjudicatarioPuntuales }}</p>
          </div>
          <div class="col text-center">
            <p>{{ total.totalPuntuales }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <div class="d-flex me-2">
              <div class="rectangulo vencidas me-1"></div>
              <p>Atrasos</p>
            </div>
          </div>
          <div class="col text-center">
            <p>{{ integrante.integranteVencidas }}</p>
          </div>
          <div class="col text-center" v-if="adjudicatarios">
            <p>{{ adjudicatario.adjudicatarioVencidas }}</p>
          </div>
          <div class="col text-center">
            <p>{{ total.totalVencidas }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <p class="ps-4">Total</p>
          </div>
          <div class="col text-center">
            <p>{{ integrante.totalIntegrante }}</p>
          </div>
          <div class="col text-center" v-if="adjudicatarios">
            <p>{{ adjudicatario.totalAdjudicatario }}</p>
          </div>
          <div class="col text-center">
            <p>{{ total.totalTotal }}</p>
          </div>
        </div>
      </div>
      <div class="container mb-4 mt-3">
        <div class="row align-items-center">
          <div class="col-2">
            <p class="fw-bold m-0">Linea de pagos total</p>
          </div>
          <div class="col">
            <div class="progress" style="height: 50px">
              <div
                class="progress-bar"
                role="progressbar"
                style="background: #ffa000"
                :style="{ width: porcentajePuntuales }"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                :title="'Puntuales: ' + porcentajePuntuales"
              >
                {{ porcentajePuntuales }}
              </div>
              <div
                class="progress-bar"
                role="progressbar"
                style="background: #302d74"
                :style="{ width: porcentajeVencidas }"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                :title="'Vencidas: ' + porcentajeVencidas"
              >
                {{ porcentajeVencidas }}
              </div>
              <div
                class="progress-bar"
                role="progressbar"
                style="background: #a3a1fb"
                :style="{ width: porcentajeAnticipo }"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                :title="'Anticipos: ' + porcentajeAnticipo"
              >
                {{ porcentajeAnticipo }}
              </div>
              <div
                class="progress-bar"
                role="progressbar"
                style="background: #e9ecef; color: black"
                :style="{ width: porcentajePorPagar }"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                :title="'Por pagar: ' + porcentajePorPagar"
              >
                {{ porcentajePorPagar }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mb-4">
        <div class="row align-items-center">
          <div class="col-2">
            <p class="fw-bold m-0">Eficiencia de pago</p>
          </div>
          <div class="col">
            <div
              class="progress"
              style="height: 50px"
              :style="{ width: tamanoBarraEficienciaPago }"
            >
              <div
                class="progress-bar"
                role="progressbar"
                style="background: #17ad61"
                :style="{ width: eficienciaPagoTotal + '%' }"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                :title="'Eficiencia de pago: ' + eficienciaPagoTotal + '%'"
              >
                {{ eficienciaPagoTotal }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { BarChart, DoughnutChart, ScatterChart } from "vue-chart-3";
import { Chart, ChartData, ChartOptions, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(...registerables);
Chart.register(ChartDataLabels);
//Chart.defaults.plugins.tooltip.interaction.intersect = false
Chart.defaults.set("plugins.datalabels", {
  display: "true",
});
Chart.defaults.set("options.layout", {
  padding: "20px",
});
Chart.defaults.set("plugins.tooltip", {
  interaction: {
    intersect: false,
  },
});
import { getCurrentInstance, onMounted, onUpdated, onUnmounted } from "vue";
export default defineComponent({
  name: "GraficaIndicePagos",

  data() {
    return {
      adjudicatarios: true,
      adjudicados: false,
      eficienciaPagoIntegrante: 0,
      eficienciaPagoAdjudicatario: 0,
      eficienciaPagoAdjudicado: 0,
      eficienciaPagoTotal: 0,

      porcentajeAnticipo: 0,
      porcentajePuntuales: 0,
      porcentajeVencidas: 0,
      porcentajePorPagar: 0,
      tamanoBarraEficienciaPago: 0,
    };
  },

  props: {
    cliente: {},
    totalContratos: Number,
    integrante: {},
    adjudicatario: {},
    total: {},
  },

  components: {
    BarChart,
    DoughnutChart,
    ScatterChart,
  },
  setup(props) {
    //props integrante
    let integranteAnticipo = Number.parseFloat(
      (props.integrante.integranteAnticipo / 180) * 100
    ).toFixed(1);
    let integrantePuntuales = Number(
      Number.parseFloat(
        (props.integrante.integrantePuntuales /
          (props.integrante.integrantePuntuales +
            props.integrante.integranteVencidas)) *
          100
      ).toFixed(1)
    );
    let integranteVencidas = Number(
      Number.parseFloat(
        (props.integrante.integranteVencidas /
          (props.integrante.integrantePuntuales +
            props.integrante.integranteVencidas)) *
          100
      ).toFixed(1)
    );

    // props adjudicatario
    let adjudicatarioAnticipo = Number(
      Number.parseFloat(
        (props.adjudicatario.adjudicatarioAnticipo / 180) * 100
      ).toFixed(1)
    );
    let adjudicatarioPuntuales = Number(
      Number.parseFloat(
        (props.adjudicatario.adjudicatarioPuntuales /
          (props.adjudicatario.adjudicatarioPuntuales +
            props.adjudicatario.adjudicatarioVencidas)) *
          100
      ).toFixed(1)
    );
    let adjudicatarioVencidas = Number(
      Number.parseFloat(
        (props.adjudicatario.adjudicatarioVencidas /
          (props.adjudicatario.adjudicatarioPuntuales +
            props.adjudicatario.adjudicatarioVencidas)) *
          100
      ).toFixed(1)
    );

    //total anticipos, total puntuales, total vencidas
    let totalAnticipo = Number(
      Number.parseFloat((props.total.totalAnticipo / 180) * 100).toFixed(1)
    );
    let totalPuntuales = Number(
      Number.parseFloat(
        (Number(props.total.totalPuntuales) /
          (props.total.totalPuntuales + props.total.totalVencidas)) *
          100
      ).toFixed(1)
    );
    let totalVencidas = Number(
      Number.parseFloat(
        (Number(props.total.totalVencidas) /
          (props.total.totalPuntuales + props.total.totalVencidas)) *
          100
      ).toFixed(1)
    );

    let porcentajeAnticipo = ((props.total.totalAnticipo / 180) * 100).toFixed(
      1
    );
    let porcentajePuntuales = (
      (props.total.totalPuntuales / 180) *
      100
    ).toFixed(1);
    let porcentajeVencidas = ((props.total.totalVencidas / 180) * 100).toFixed(
      1
    );

    let porcentajePorPagar = (
      100 -
      (Number(porcentajeAnticipo) +
        Number(porcentajePuntuales) +
        Number(porcentajeVencidas))
    ).toFixed(1);
    let tamanoBarraEficienciaPago =
      (Number(porcentajePuntuales) + Number(porcentajeVencidas)).toFixed(1) +
      "%";

    //Armamos los arreglos para la gráfica de pagos integrante
    let datasetIntegranteAnticipo = [];
    let datasetIntegrantePuntualesVencidas = [];
    let datasetIntegranteAnticipoColores = [];
    let datasetIntegrantePuntualesVencidasColores = [];

    //Armamos los arreglos para la gráfica de pagos adjudicatario
    let datasetAdjudicatarioAnticipo = [];
    let datasetAdjudicatarioPuntualesVencidas = [];
    let datasetAdjudicatarioAnticipoColores = [];
    let datasetAdjudicatarioPuntualesVencidasColores = [];

    //Armamos los arreglos para la gráfica de pagos total
    let datasetTotalAnticipo = [];
    let datasetTotalPuntualesVencidas = [];
    let datasetTotalAnticipoColores = [];
    let datasetTotalPuntualesVencidasColores = [];

    //Validamos que los anticipos, vencidas y puntualaes existan en cada una de las etapas (diferentes de 0), de lo contrario, los omitimos
    onMounted(() => {
      getCurrentInstance().data.eficienciaPagoIntegrante = (
        (Number(integrantePuntuales) /
          (Number(integrantePuntuales) + Number(integranteVencidas))) *
        100
      ).toFixed(1);
      
      //Parche para mostra 0 en caso de no tener valores.
      const puntuales = Number(adjudicatarioPuntuales) || 0;
      const vencidas = Number(adjudicatarioVencidas) || 0;
      const total = puntuales + vencidas;
      getCurrentInstance().data.eficienciaPagoAdjudicatario = total > 0
        ? ((puntuales / total) * 100).toFixed(1)
        : 0;

      
      getCurrentInstance().data.eficienciaPagoTotal = (
        (Number(totalPuntuales) /
          (Number(totalPuntuales) + Number(totalVencidas))) *
        100
      ).toFixed(1);

      getCurrentInstance().data.porcentajeAnticipo = porcentajeAnticipo + "%";
      getCurrentInstance().data.porcentajePuntuales = porcentajePuntuales + "%";
      getCurrentInstance().data.porcentajeVencidas = porcentajeVencidas + "%";
      getCurrentInstance().data.porcentajePorPagar = porcentajePorPagar + "%";
      getCurrentInstance().data.tamanoBarraEficienciaPago =
        tamanoBarraEficienciaPago;

      if (
        props.adjudicatario.adjudicatarioAnticipo +
          props.adjudicatario.adjudicatarioPuntuales +
          props.adjudicatario.adjudicatarioVencidas >
        0
      ) {
        getCurrentInstance().data.adjudicatarios = true;
      }

      for (const key in props.cliente.indicePagos.ponderadosAdjudicatario) {
        if (props.cliente.indicePagos.ponderadosAdjudicatario[key] > 0) {
          getCurrentInstance().data.adjudicatarios = true;
          break;
        }
      }

      for (const key in props.cliente.indicePagos.ponderadosAdjudicado) {
        if (props.cliente.indicePagos.ponderadosAdjudicado[key] > 0) {
          getCurrentInstance().data.adjudicados = true;
          break;
        }
      }
    });
    // Datos de la grafica Integrante
    //Dataset 1 Anticipos Integrante
    datasetIntegranteAnticipo.push(integranteAnticipo);
    let integranteAnticipoResiduo = 100 - integranteAnticipo;
    if (datasetIntegranteAnticipo < 100 && integranteAnticipo != 0) {
      datasetIntegranteAnticipo.push(integranteAnticipoResiduo);
      datasetIntegranteAnticipoColores = [
        "rgba(163, 161, 251, 1)",
        "rgba(255,255,255,0)",
      ];
    }
    //Dataset 2 Puntuales y Vencidas Integrante
    if (integranteVencidas > 0 && integrantePuntuales > 0) {
      datasetIntegrantePuntualesVencidas.push(integrantePuntuales);
      datasetIntegrantePuntualesVencidas.push(integranteVencidas);
      datasetIntegrantePuntualesVencidasColores = [
        "rgba(255, 160, 0, 1)",
        "rgba(48, 45, 116, 1)",
      ];
    } else if (integrantePuntuales >= 100) {
      datasetIntegrantePuntualesVencidas.push(integrantePuntuales);
      datasetIntegrantePuntualesVencidasColores = ["rgba(255, 160, 0, 1)"];
    } else if (integranteVencidas >= 100) {
      datasetIntegrantePuntualesVencidas.push(integranteVencidas);
      datasetIntegrantePuntualesVencidasColores = ["rgba(48, 45, 116, 1)"];
    } else if (integranteVencidas > 0 && integrantePuntuales == 0) {
      datasetIntegrantePuntualesVencidas.push(integranteVencidas);
      let IntegrantePuntualesVencidasResiduo = (
        100 - integranteVencidas
      ).toFixed(2);
      datasetIntegrantePuntualesVencidas.push(
        IntegrantePuntualesVencidasResiduo
      );
      datasetIntegrantePuntualesVencidasColores = [
        "rgba(48, 45, 116, 1)",
        "rgba(255,255,255,0)",
      ];
    } else if (integranteVencidas == 0 && integrantePuntuales > 0) {
      datasetIntegrantePuntualesVencidas.push(integrantePuntuales);
      let IntegrantePuntualesVencidasResiduo = (
        100 - integrantePuntuales
      ).toFixed(2);
      datasetIntegrantePuntualesVencidas.push(
        IntegrantePuntualesVencidasResiduo
      );
      datasetIntegrantePuntualesVencidasColores = [
        "rgba(255, 160, 0, 1)",
        "rgba(255,255,255,0)",
      ];
    }
    // Datos de la grafica Adjudicatario
    //Dataset 1 Anticipos Adjudicatario
    datasetAdjudicatarioAnticipo.push(adjudicatarioAnticipo);
    let adjudicatarioAnticipoResiduo = 100 - adjudicatarioAnticipo;
    if (
      datasetAdjudicatarioAnticipo < 100 &&
      datasetAdjudicatarioAnticipo > 0
    ) {
      datasetAdjudicatarioAnticipo.push(adjudicatarioAnticipoResiduo);
      datasetAdjudicatarioAnticipoColores = [
        "rgba(163, 161, 251, 1)",
        "rgba(255,255,255,0)",
      ];
    }
    //Dataset 2 Puntuales y Vencidas Adjudicatario
    if (adjudicatarioVencidas > 0 && adjudicatarioPuntuales > 0) {
      datasetAdjudicatarioPuntualesVencidas.push(adjudicatarioPuntuales);
      datasetAdjudicatarioPuntualesVencidas.push(adjudicatarioVencidas);
      datasetAdjudicatarioPuntualesVencidasColores = [
        "rgba(255, 160, 0, 1)",
        "rgba(48, 45, 116, 1)",
      ];
    } else if (adjudicatarioPuntuales >= 100) {
      datasetAdjudicatarioPuntualesVencidas.push(adjudicatarioPuntuales);
      datasetAdjudicatarioPuntualesVencidasColores = ["rgba(255, 160, 0, 1)"];
    } else if (adjudicatarioVencidas >= 100) {
      datasetAdjudicatarioPuntualesVencidas.push(adjudicatarioVencidas);
      datasetAdjudicatarioPuntualesVencidasColores = ["rgba(48, 45, 116, 1)"];
    } else if (adjudicatarioVencidas > 0 && adjudicatarioPuntuales == 0) {
      datasetAdjudicatarioPuntualesVencidas.push(adjudicatarioVencidas);
      let AdjudicatarioPuntualesVencidasResiduo = (
        100 - adjudicatarioVencidas
      ).toFixed(2);
      datasetAdjudicatarioPuntualesVencidas.push(
        AdjudicatarioPuntualesVencidasResiduo
      );
      datasetAdjudicatarioPuntualesVencidasColores = [
        "rgba(48, 45, 116, 1)",
        "rgba(255,255,255,0)",
      ];
    } else if (adjudicatarioVencidas == 0 && adjudicatarioPuntuales > 0) {
      datasetAdjudicatarioPuntualesVencidas.push(adjudicatarioPuntuales);
      let AdjudicatarioPuntualesVencidasResiduo = (
        100 - adjudicatarioPuntuales
      ).toFixed(2);
      datasetAdjudicatarioPuntualesVencidas.push(
        AdjudicatarioPuntualesVencidasResiduo
      );
      datasetAdjudicatarioPuntualesVencidasColores = [
        "rgba(255, 160, 0, 1)",
        "rgba(255,255,255,0)",
      ];
    }
    // Datos de la grafica Total
    //Dataset 1 Anticipos Total
    datasetTotalAnticipo.push(totalAnticipo);
    let totalAnticipoResiduo = 100 - totalAnticipo;
    if (datasetTotalAnticipo < 100 && datasetTotalAnticipo > 0) {
      datasetTotalAnticipo.push(totalAnticipoResiduo);
      datasetTotalAnticipoColores = [
        "rgba(163, 161, 251, 1)",
        "rgba(255,255,255,0)",
      ];
    }
    //Dataset 2 Puntuales y Vencidas Total
    if (totalVencidas > 0 && totalPuntuales > 0) {
      datasetTotalPuntualesVencidas.push(totalPuntuales);
      datasetTotalPuntualesVencidas.push(totalVencidas);
      datasetTotalPuntualesVencidasColores = [
        "rgba(255, 160, 0, 1)",
        "rgba(48, 45, 116, 1)",
      ];
    } else if (totalPuntuales >= 100) {
      datasetTotalPuntualesVencidas.push(totalPuntuales);
      datasetTotalPuntualesVencidasColores = ["rgba(255, 160, 0, 1)"];
    } else if (totalVencidas >= 100) {
      datasetTotalPuntualesVencidas.push(totalVencidas);
      datasetTotalPuntualesVencidasColores = ["rgba(48, 45, 116, 1)"];
    } else if (totalVencidas > 0 && totalPuntuales == 0) {
      datasetTotalPuntualesVencidas.push(totalVencidas);
      let totalPuntualesVencidasResiduo = 100 - totalVencidas;
      datasetTotalPuntualesVencidas.push(totalPuntualesVencidasResiduo);
      datasetTotalPuntualesVencidasColores = [
        "rgba(48, 45, 116, 1)",
        "rgba(255,255,255,0)",
      ];
    } else if (totalVencidas == 0 && totalPuntuales > 0) {
      datasetTotalPuntualesVencidas.push(totalPuntuales);
      let totalPuntualesVencidasResiduo = 100 - totalPuntuales;
      datasetTotalPuntualesVencidas.push(totalPuntualesVencidasResiduo);
      datasetTotalPuntualesVencidasColores = [
        "rgba(255, 160, 0, 1)",
        "rgba(255,255,255,0)",
      ];
    }

    //Grafica Integrante
    const datosIntegrante = {
      options: {
        plugins: {
          tooltip: {
            intersect: false,
          },
        },
      },

      datasets: [
        {
          data: datasetIntegranteAnticipo,
          fill: false,
          borderColor: datasetIntegranteAnticipoColores,
          backgroundColor: datasetIntegranteAnticipoColores,
          tension: 0,
          showLine: false,
          datalabels: {
            formatter: (value, ctx) => {
              return value + "%";
            },
            color: "#FFF",
            backgroundColor: datasetIntegranteAnticipoColores,
            align: "center",
            labels: {
              title: {
                font: {
                  size: "12px",
                  weight: "bold",
                },
              },
            },
          },
        },
        {
          data: datasetIntegrantePuntualesVencidas,
          fill: false,
          borderColor: datasetIntegrantePuntualesVencidasColores,
          backgroundColor: datasetIntegrantePuntualesVencidasColores,
          tension: 0,
          showLine: false,
          datalabels: {
            formatter: (value, ctx) => {
              return value + "%";
            },
            color: "#FFF",
            backgroundColor: datasetIntegrantePuntualesVencidasColores,
            align: "center",
            labels: {
              title: {
                font: {
                  size: "12px",
                  weight: "bold",
                },
              },
            },
          },
        },
      ],
    };
    //Grafica Adjudicatario
    const datosAdjudicatario = {
      options: {
        plugins: {
          tooltip: {
            intersect: false,
          },
        },
      },
      datasets: [
        {
          data: datasetAdjudicatarioAnticipo,
          fill: false,
          borderColor: datasetAdjudicatarioAnticipoColores,
          backgroundColor: datasetAdjudicatarioAnticipoColores,
          tension: 0,
          showLine: false,
          datalabels: {
            formatter: (value, ctx) => {
              return value + "%";
            },
            color: "#FFF",
            backgroundColor: datasetAdjudicatarioAnticipoColores,
            align: "center",
            labels: {
              title: {
                font: {
                  size: "12px",
                  weight: "bold",
                },
              },
            },
          },
        },
        {
          data: datasetAdjudicatarioPuntualesVencidas,
          fill: false,
          borderColor: datasetAdjudicatarioPuntualesVencidasColores,
          backgroundColor: datasetAdjudicatarioPuntualesVencidasColores,
          tension: 0,
          showLine: false,
          datalabels: {
            formatter: (value, ctx) => {
              return value + "%";
            },
            color: "#FFF",
            backgroundColor: datasetAdjudicatarioPuntualesVencidasColores,
            align: "center",
            labels: {
              title: {
                font: {
                  size: "12px",
                  weight: "bold",
                },
              },
            },
          },
        },
      ],
    };
    //Grafica Total
    const datosTotal = {
      options: {
        plugins: {
          tooltip: {
            intersect: false,
          },
        },
      },
      datasets: [
        {
          data: datasetTotalAnticipo,
          fill: false,
          borderColor: datasetTotalAnticipoColores,
          backgroundColor: datasetTotalAnticipoColores,
          tension: 0,
          showLine: false,
          datalabels: {
            formatter: (value, ctx) => {
              return value + "%";
            },
            color: "#FFF",
            backgroundColor: datasetTotalAnticipoColores,
            align: "center",
            labels: {
              title: {
                font: {
                  size: "12px",
                  weight: "bold",
                },
              },
            },
          },
        },
        {
          data: datasetTotalPuntualesVencidas,
          fill: false,
          borderColor: datasetTotalPuntualesVencidasColores,
          backgroundColor: datasetTotalPuntualesVencidasColores,
          tension: 0,
          showLine: false,
          datalabels: {
            formatter: (value, ctx) => {
              return value + "%";
            },
            color: "#FFF",
            backgroundColor: datasetTotalPuntualesVencidasColores,
            align: "center",
            labels: {
              title: {
                font: {
                  size: "12px",
                  weight: "bold",
                },
              },
            },
          },
        },
      ],
    };
    //Grafica linea de pagos total y eficiencia de pago
    return { datosIntegrante, datosAdjudicatario, datosTotal };
  },
});
</script>
<style lang="scss" scoped>
@import "src/sass/estilos-generales.scss";
.rectangulo {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.anticipos {
  background: rgba(163, 161, 251, 1);
}
.puntuales {
  background: rgba(255, 160, 0, 1);
}
.vencidas {
  background: rgba(48, 45, 116, 1);
}
.noContratos {
  background-color: $primary;
  padding: 10px;
  border-radius: 10px;
}
.noContratos p {
  color: $white;
  font-size: 18px;
  font-weight: 600;
}
.noContratos p span {
  font-size: 24px;
  font-weight: 600;
  padding-left: 5px;
}
.noContratos {
  background-color: $primary;
  padding: 10px;
  border-radius: 10px;
}
.noContratos p {
  color: $white;
  font-size: 18px;
  font-weight: 600;
}
.noContratos p span {
  font-size: 24px;
  font-weight: 600;
  padding-left: 5px;
}
.noContratos {
  background-color: $primary;
  padding: 10px;
  border-radius: 10px;
}
.noContratos p {
  color: $white;
  font-size: 18px;
  font-weight: 600;
}
.noContratos p span {
  font-size: 24px;
  font-weight: 600;
  padding-left: 5px;
}
</style>
